import { init, configureScope } from '@sentry/browser';

export async function initSentry() {
  init({
    dsn: 'https://a15076dca0684c81903c7899fd2f7692@sentry.io/1196449',
    whitelistUrls: [
      'https://d2mr2bp22s0zi7.cloudfront.net',
      'https://campsite.bio',
      'https://app.campsite.bio',
    ],
    ignoreErrors: [
      // Random plugins/extensions
      'top.GLOBALS',
      'Redirected when going from',
      'Permission denied to access property',
      "undefined is not an object (evaluating 'a.R')",
      // ResizeObserver noise
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications',
      // Android WebView noise
      'Java object is gone',
      /Error invoking/,
      // iOS WebView / in-app browser noise
      /window\.webkit\.messageHandlers/,
      // Media playback noise (user browser/device limitations)
      'NotSupportedError: The element has no supported sources',
      'NotSupportedError: Failed to load because no supported source was found',
      'NotAllowedError: play() can only be initiated by a user gesture',
      // Browser extensions
      'Invalid call to runtime.sendMessage()',
      'Failed to connect to MetaMask',
      // Browser feature detection
      "feature named `performanceMetrics` was not found",
    ],
    denyUrls: [
      // Facebook blocked
      /connect\.facebook\.net\/en_US\/all\.js/i,
      // Chrome extensions
      /extensions\//i,
      /^chrome:\/\//i,
      /^moz-extension:\/\//i,
      /^safari-extension:\/\//i,
    ],
  });
}

export async function configureUser(user) {
  if (!user || Object.keys(user).length === 0) return;

  configureScope((scope) => {
    scope.setUser({ id: user._id.$oid, email: user.email });
  });
}
